import { i18n } from '@fs/zion-locale'

export default {
  ancestors: () => i18n.t('VolumeSetPreviewPane.ancestors', 'First Ancestor/Migrant Ancestor'),
  ancestralHall: () => i18n.t('VolumeSetPreviewPane.ancestralHall', 'Ancestral Hall'),
  author: () => i18n.t('VolumeSetPreviewPane.author', 'Author'),
  clan: () => i18n.t('VolumeSetPreviewPane.clan', 'Clan'),
  clanBranches: () => i18n.t('VolumeSetPreviewPane.clanBranch', 'Clan Branches'),
  date: () => i18n.t('VolumeSetPreviewPane.date', 'Date'),
  generationPoem: () => i18n.t('VolumeSetPreviewPane.generationPoem', 'Generation Poem'),
  myJiapuCheckbox: () => i18n.t('VolumeSetPreviewPane.checkbox.thisIsMyJiapu', 'This is my jiapu'),
  myJokboCheckbox: () => i18n.t('VolumeSetPreviewPane.checkbox.thisIsMyJokbo', 'This is my jokbo'),
  myKeizuCheckbox: () => i18n.t('VolumeSetPreviewPane.checkbox.thisIsMyKeizu', 'This is my keizu'),
  noImageWarningMessage: () =>
    i18n.t(
      'VolumeSetPreviewPane.noImageWarningMessage',
      "Unfortunately, we don't have any images to share for this jiapu. Please try again at a later date. We will add more images as they become available."
    ),
  notes: () => i18n.t('VolumeSetPreviewPane.notes', 'Notes'),
  place: () => i18n.t('VolumeSetPreviewPane.place', 'Place'),
  recordPreview: () => i18n.t('VolumeSetPreviewPane.recordPreview', 'Jiapu preview'),
  showLess: () => i18n.t('VolumeSetPreviewPane.showLessButton', 'Less'),
  showMore: () => i18n.t('VolumeSetPreviewPane.showMoreButton', 'More'),
  surname: () => i18n.t('VolumeSetPreviewPane.surname', 'Surname'),
  viewImages: () => i18n.t('jiapuPreview.viewImagesButton', 'View Images'),
  volumes: () => i18n.t('VolumeSetPreviewPane.volumes', 'Volumes'),
}
